import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IAdditionalFields, IResultNavigationDetails, IResultPageState } from '@common/models';
import { HttpRequestPayload, IHttpErrorPayload, IHttpSuccessPayload } from '@core/models';
import { HttpProviderService } from '@core/service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { CommonService } from 'src/app/common.service';
import { EntryShellService } from 'src/app/pages/entry-shell/services/entry-shell.service';

@Injectable({
  providedIn: 'root',
})
export class ResultPageService {
  paymentData: any;
  private transactionModules = ["accounts", "debit-cards", "loans", "credit-cards", "deposits"];
  private loginModules = ["otp-auth","reset-password"];
  resultPageUrl: any;
  additionalFields: IAdditionalFields[];
  
  
  constructor(private _httpProvider: HttpProviderService, 
    private _shellService:EntryShellService,
    private _router:Router,
    private _commonService: CommonService,
    public translate: TranslateService,
    ) {
      if(this._commonService.isDesktop()) {
        this.resultPageUrl = ['home','transactions','result'];
      }
      else {
        this.resultPageUrl = ['shell','result'];
      }
    }

  private title: string = 'Done';
  private message: string;
  private alertType: 'Success' | 'Warning' | 'Failed';
  private navigationDtls: IResultNavigationDetails[] ;
  private resultPayload: IHttpSuccessPayload<any> | IHttpErrorPayload;
  private serviceCode : string ;
  private successMsgNumber : string;

   setTitle(title: string) {
    this.title = title;
  }

  setService(serviceCode: string) {
    this.serviceCode = serviceCode;
  }

   setResultPayload(resultPayload: IHttpSuccessPayload<any> | IHttpErrorPayload) {
    this.resultPayload = resultPayload;
  }
  setSuccessMsgNumber(successMsgNumber) {
    this.successMsgNumber = successMsgNumber;
  }

  setPaymentData(data) {
    this.paymentData = data;
  }
  setAdditionalFields(data:IAdditionalFields[]) {
    this.additionalFields = data;
  }

  setSuccess(additionNavigation = null){
    this.alertType = 'Success';
    let moduleName:string = this._router.url.split('/')[2];
    let navPath:string[] = [];
    
    if(this.transactionModules.includes(moduleName)){
      navPath = ['home', 'transactions'];
    } else if(moduleName == 'payment') {
      navPath = ['home', 'transfers'];
    } else if(this.loginModules.includes(moduleName)){
      navPath = ['login'];
    } else {
      navPath = ['home', moduleName];
    }
    this.navigationDtls = [
      {
        path: navPath,
        state: {},
        btnLabel: this.translate.instant('FORM_ACTIONS.close'),
        btnType: 'primary',
      },
    ];
    if(this.paymentData && additionNavigation) {
      this.navigationDtls.unshift(additionNavigation);
    }
    this.title = this.translate.instant('RESULTSUCCESSSMESSGAE.successful');
  }

  setFailure(retryUrl = ['home','transactions']){
    this.alertType = 'Failed';
    this.navigationDtls = [{
      path : retryUrl,
      state : {},
      btnLabel : 'Retry',
     }];
     this.message = this.translate.instant('RESULTPAGEMESSAGE.COMMONFAILUREMESSAGE');
     this.title = this.translate.instant('RESULTPAGEMESSAGE.COMMONFAILURETITLE');
  }
 
  get resultPageData(): IResultPageState {
    return {
      title: this.title,
      message: this.message,
      alertType: this.alertType,
      navigationDtls: this.navigationDtls,
      resultPayload: this.resultPayload,
      serviceCode : this.serviceCode,
      paymentData: this.paymentData,
      resultPageUrl: this.resultPageUrl,
      additionalFields: this.additionalFields,
      successMsgNumber: this.successMsgNumber
    };
  }

  resetResultPageData() {
    this.title = '';
    this.message = '';
    this.alertType = undefined;
    this.navigationDtls = [];
    this.resultPayload = undefined;
    this.serviceCode = '';
    this.paymentData = undefined;
    this.additionalFields = undefined;
    this.successMsgNumber = undefined;
  }

  makeFavoritePayment(payload): Observable<any> {
    const httpRequest : HttpRequestPayload = {
      resource : '/favouritepayments',
      method : "POST",
      body: payload
    }
    return this._httpProvider.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      return response.body
    },
    catchError((err : IHttpErrorPayload) => { 
      return throwError(err)
    })));
  }
  makeUnFavoritePayment(inventoryNo): Observable<any> {
    const httpRequest : HttpRequestPayload = {
      resource : '/favouritepayments/'+inventoryNo,
      method : "DELETE"
    }
    return this._httpProvider.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      return response.body
    },
    catchError((err : IHttpErrorPayload) => { 
      return throwError(err)
    })));
  }
}
